import { useLocation, matchPath, RedirectFunction, redirect } from 'react-router-dom'

export const useRouteMatch = (patterns: readonly string[], params: { includes?: boolean } = {}) => {
  const { pathname } = useLocation()
  const { includes } = params

  for (const pattern of patterns) {
    const possibleMatch = matchPath(pattern, pathname)
    if (possibleMatch !== null) {
      return possibleMatch
    }
  }

  return null
}

export const replace: RedirectFunction = (url, init) => {
  const response = redirect(url, init)
  response.headers.set('X-Remix-Replace', 'true')
  return response
}
